function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.98 3.02a3.43 3.43 0 00-3.29-.91l-9.8 2.45a4.56 4.56 0 00-3.33 3.33L2.11 17.7c-.3 1.19.04 2.42.91 3.29.66.65 1.53 1.01 2.43 1.01.28 0 .57-.03.85-.11l9.81-2.45a4.56 4.56 0 003.33-3.33l2.45-9.81c.3-1.19-.04-2.42-.91-3.28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.88a3.88 3.88 0 100-7.76 3.88 3.88 0 000 7.76z"
})));